const MIGRATION_KEY = 'ziggu_migration_filter_undefined';

export default function runFilterUndefinedMigration() {
  if (localStorage.getItem(MIGRATION_KEY)) return;

  const keys_to_remove = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key.startsWith('filter_undefined_')) keys_to_remove.push(key);
  }
  keys_to_remove.forEach((key) => localStorage.removeItem(key));

  localStorage.setItem(MIGRATION_KEY, new Date().toISOString());
}
